import { IChecklistInitialState } from "./types";

const initialState: IChecklistInitialState = {
  equipmentStatus: {},
};

export default initialState;

